import { FC } from "react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  source: string | any;
  label?: string;
  name?: string;
  child?: string;
}

const BooleanField: FC<Props> = ({ source, child }) => {
  if (source && child) {
    return (
      <div>
        {source[child] ? (
          <CheckIcon color="success" />
        ) : (
          <CloseIcon color="error" />
        )}
      </div>
    );
  } else {
    return (
      <div>
        {source ? <CheckIcon color="success" /> : <CloseIcon color="error" />}
      </div>
    );
  }
};

export default BooleanField;
